import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthScreen from './screens/AuthScreen';
import SourcesScreen from './screens/SourcesScreen';
import BriefScreen from './screens/BriefScreen';
import HistoryScreen from './screens/HistoryScreen';
import DiscoverScreen from './screens/DiscoverScreen';
import ProfileScreen from './screens/ProfileScreen';
import AboutScreen from './screens/AboutScreen';
import Nav from './components/Nav';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('vb_user');
    const token = localStorage.getItem('vb_token');
    if (stored && token) {
      setUser(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('vb_token', token);
    localStorage.setItem('vb_user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('vb_token');
    localStorage.removeItem('vb_user');
    setUser(null);
  };
  const handleUserUpdate = (updatedFields) => {
    const updated = { ...user, ...updatedFields };
    localStorage.setItem('vb_user', JSON.stringify(updated));
    setUser(updated);
  };

  if (loading) return null;

  return (
    <BrowserRouter>
      {user && <Nav user={user} onLogout={handleLogout} />}
      <Routes>
        <Route
          path="/"
          element={user ? <Navigate to="/brief" /> : <AuthScreen onLogin={handleLogin} />}
        />
        <Route
          path="/brief"
          element={user ? <BriefScreen user={user} /> : <Navigate to="/" />}
        />
        <Route
          path="/sources"
          element={user ? <SourcesScreen user={user} /> : <Navigate to="/" />}
        />
        <Route
          path="/history"
          element={user ? <HistoryScreen /> : <Navigate to="/" />}
        />
        <Route
          path="/discover"
          element={user ? <DiscoverScreen user={user} /> : <Navigate to="/" />}
        />
        <Route
          path="/profile"
          element={user ? <ProfileScreen user={user} onLogout={handleLogout} onUpdate={handleUserUpdate} /> : <Navigate to="/" />}
        />
        <Route
          path="/about"
          element={<AboutScreen user={user} />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
